import { useMutation, useQueryClient } from '@tanstack/react-query';

import { metricsApi } from '../api';

interface UseDeleteNapDetailsParams {
  userId: string;
  metricId: string;
  date: string;
  metricNapId: string;
}

export function useDeleteNapDetails() {
  const queryClient = useQueryClient();

  const deleteNapDetailMutation = useMutation({
    mutationFn: ({ userId, metricId, date, metricNapId }: UseDeleteNapDetailsParams) => {
      return metricsApi.deleteNapDetails(metricId, userId, date, metricNapId);
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['lifestack.sleep.details'] });
    },
  });

  return {
    deleteNapDetail: deleteNapDetailMutation.mutateAsync,
    ...deleteNapDetailMutation,
  };
}
